import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { getCardImagePath } from '../../../utils/credit-cards';
export const CardInfo = ({ card }) => (React.createElement("div", { className: "sui-flex sui-flex-wrap sui-items-center" },
    React.createElement("img", { width: 50, height: "auto", className: "sui-inline-block sui-mr-4", src: getCardImagePath((card === null || card === void 0 ? void 0 : card.cardBrand) || '', (card === null || card === void 0 ? void 0 : card.cardType) || ''), alt: "Credit card logo" }),
    React.createElement("div", { className: "sui-mr-4" },
        React.createElement(Typography, { variant: "body-lg", color: "subtle" },
            "****", card === null || card === void 0 ? void 0 :
            card.cardNumberLast4,
            " ", card === null || card === void 0 ? void 0 :
            card.buyerId)),
    card.cardExpiryMonth && card.cardExpiryYear && (React.createElement(Typography, { variant: "body-lg", color: "subtle" }, `Exp ${card.cardExpiryMonth}/${card.cardExpiryYear.slice(-2)}`))));
